import React from 'react';

const MentionsLegales = () => {
  return (
    <main className="bg-white min-h-screen pt-28 pb-16 px-6 sm:px-8">
      <div className="max-w-4xl mx-auto text-gray-800">
        <h1 className="text-3xl sm:text-4xl font-semibold text-[#1e3a5f] mb-8">Mentions legales</h1>

        <section className="space-y-4 mb-8">
          <h2 className="text-xl font-medium">Editeur du site</h2>
          <p>MN Medecine Esthetique</p>
          <p>Responsable de publication: Dr Massinissa Ghelboun et Dr Nacer Ghelboun</p>
          <p>Adresse: 90 rue Louis Daubenton, 62320 Rouvroy, France</p>
          <p>Telephone: 06 85 95 10 05</p>
          <p>Email: medesthetique@outlook.com</p>
          <p>SIRET: A completer</p>
        </section>

        <section className="space-y-4 mb-8">
          <h2 className="text-xl font-medium">Hebergement</h2>
          <p>Amazon Web Services (AWS)</p>
          <p>Amazon Web Services EMEA SARL</p>
          <p>38 Avenue John F. Kennedy, L-1855, Luxembourg</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-medium">Propriete intellectuelle</h2>
          <p>
            L&apos;ensemble du contenu de ce site (textes, images, graphismes, logo, videos) est protege par le droit
            de la propriete intellectuelle. Toute reproduction, distribution ou utilisation sans autorisation prealable
            est interdite.
          </p>
        </section>
      </div>
    </main>
  );
};

export default MentionsLegales;
